import React, { useState, useEffect, useRef } from "react";

/** Helper */
import { useNavigate, useParams } from "react-router-dom";
import { getDataRequest } from "../../../../helper/AxiosHelper";
import { toast } from "react-toastify";
/** Component */
import {
    Box,
    Grid,
    Typography,
    Container,
    Stack,
    Button,
    Divider,
    Paper,
} from "@mui/material";
// import CommonTable from "../../components/common/CommonTable";
// import CommonFilter from "../../components/common/CommonFilter";
// import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";
import CommonTable from "../../../../components/common/CommonTable";
import CommonFilter from "../../../../components/common/CommonFilter";

import { AdminApi } from "../../../../api/AdminApi";

import TableConfig from "./BatchFaceIDTableContent";

export default function BatchFaceIDSetupForm({ orgID }) {
    const inputRef = useRef(null);
    const [filterQuery, setFilterQuery] = useState([]);
    const [files, setFiles] = useState(null);


    const handleFileChange = (e) => {
        const target = e.target;
        const files = target.files;
        console.debug("files=", files);
        if (files && files.length > 0) {
            //setFile(files[0]);
            setFiles(files);
        }
    }

    const extractID = (filename) => {
        let token = filename.split("_");
        if (token.length <= 1) {
            return 0;
        }

        return token[1];
    }

    const submitFile = async (file) => {
        let filename = file.name;
        let id = extractID(filename);

        if (id <= 0) {
            console.log("Invalid ID: ", id);
            toast.error(filename + ": Invalid ID: " + id);
            return;
        }
        let data = { photo: file };

        await AdminApi.enrollMemberFace(id, data, (isSuccess, msg, result) => {
            if (isSuccess) {
                toast.success(filename + ": " + msg);
            }
            else {
                toast.error(filename + ": " + msg);
            }
        });


        // await AdminApi.enrollMemberFace(id, file, (isSuccess, msg, result) => {
        //     if (isSuccess) {
        //         toast.success(filename + ": " + msg);
        //     } else {
        //         toast.error(filename + ": " + msg);
        //     }
        // });
    }


    const handleBatchSetupFaceID = async () => {
        console.log("handleBatchSetupFaceID: ", files);
        // const _callback = (isSuccess, msg, result) => {
        console.log("File Listing");
        for (let i = 0; i < files.length; i++) {
            let fileObject = files[i];
            // console.log("handleBatchSetupFaceID: fileObject: ", fileObject);
            submitFile(fileObject);
        }
    };

    const getFileInfo = (fileList) => {
        let info = "";

        if (fileList && fileList.length > 0) {
            for (let file of fileList) {
                info += file.name + "\n";
            }

            // info = fileList.map((file) => {
            //     return file.name;
            // }).join(", ");
        }

        return info;
    }

    const fileBox = files ? (
        <Box>
            {getFileInfo(files)}
        </Box>
    ) : (
        <Box>no file selected</Box>
    );



    //  file ? (
    //     <Box>{file.name}</Box>
    // ) : (
    //     <Box>no file selected</Box>
    // );

    return (
        <Box sx={{ p: 1, }}>
            <Paper sx={{ px: 3, pb: 3, mt: 6 }} elevation={3}>
                <Grid container rowSpacing={1} columnSpacing={1}>
                    <Grid item xs={12}>
                        <Stack
                            direction={"row"}
                            justifyContent={"space-between"}
                            alignItems={"center"}
                        >
                            <pre>orgID: {orgID} </pre>
                            {/* Filter */}
                            <Box>
                                <CommonFilter
                                    filterConfig={TableConfig.filterConfig}
                                    emitQueryFn={setFilterQuery}
                                />
                            </Box>

                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <CommonTable
                            filterQuery={filterQuery}
                            tableConfig={TableConfig}
                            urlParma={{ orgId: orgID }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Stack sx={{ mt: 2 }} direction="row" gap={3} alignItems="center">
                        <Typography variant="body1">圖片文件：</Typography>

                        <Box sx={{ whiteSpace: 'pre-line' }}>
                            {fileBox}
                        </Box>

                        <Button
                            variant="outlined"
                            component="label"
                        >
                            Select Files
                            <input
                                type="file"
                                hidden
                                multiple
                                ref={inputRef}

                                onChange={handleFileChange}
                            />
                        </Button>


                        <Button
                            variant="contained"
                            component="label"
                            onClick={handleBatchSetupFaceID}
                        >
                            批量設定FaceID
                        </Button>

                    </Stack>
                </Grid>
            </Paper>
        </Box>
    );
}
